import { useApiStore } from "@/stores/api/index.ts";
import getDefaultOpts from "@/store/utils/getDefaultOpts.js";

async function resetHomeCategories(categoryId, module) {
  const { rootGetters, dispatch } = module;
  const gridCategoryId = rootGetters.getStoreVar(
    "Home",
    "styling",
    "dropdown",
    "gridCategoryId"
  );
  const carouselCategoryIds = rootGetters.getStoreVar(
    "Home",
    "styling",
    "dropdown",
    "carouselCategoryIds"
  );

  if (categoryId === gridCategoryId) {
    await dispatch("saveSiteData", {
      dataKey: ["Home", "styling", "dropdown", "gridCategoryId"],
      value: "",
    });
  }
  if (carouselCategoryIds.includes(categoryId)) {
    await dispatch("saveSiteData", {
      dataKey: ["Home", "styling", "dropdown", "carouselCategoryIds"],
      value: carouselCategoryIds.filter((id) => id !== categoryId),
    });
  }
}

const deleteCategory = async (module, { path, opts = {} }) => {
  const api = useApiStore();
  const { commit, dispatch } = module;
  const config = Object.assign(getDefaultOpts(), opts);
  const id = path.split("/")[2];
  await dispatch("httpRequest", {
    func: api.deleteCategory(id),
    config,
  });
  await resetHomeCategories(id, module);
  await dispatch("fetchCategoryTree");
  commit("removeCategory", path);
  await dispatch("fetchCategories", { opts });
};

export { deleteCategory };
